import { render, staticRenderFns } from "./RiwayatWithdrawalTunai.vue?vue&type=template&id=5accd56f&scoped=true&"
import script from "./RiwayatWithdrawalTunai.vue?vue&type=script&lang=js&"
export * from "./RiwayatWithdrawalTunai.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5accd56f",
  null
  
)

export default component.exports